// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face {\n  font-family: 'MinionPro';\n  src: url(\"/fonts/MinionPro-Regular.otf\") format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'MinionPro';\n  src: url(\"/fonts/MinionPro-Italic.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: italic;\n}\n@font-face {\n  font-family: 'MinionPro-Italic';\n  src: url(\"/fonts/MinionPro-Italic.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: italic;\n}", ""]);
// Exports
module.exports = exports;
